import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from '../api.service';
import { LocationService } from '../location.service';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { LaunchNavigatorOptions, LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { DomSanitizer } from '@angular/platform-browser';

declare var google; let k = 1;
// declare var userLatLng, custLatLng, custLat;
@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss'],
})
export class RequestsComponent {
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  loader: boolean = true;
  change: boolean = false;
  mapView: boolean = true;
  imgView: boolean = false;
  button: boolean = true;
  active: boolean = false;
  itemOrders: any = [];
  popImg: any;
  notes;
  actCost;
  vendorFlow: boolean;
  orgFlow: boolean;
  adminFlow: boolean;
  pendingOrders: any = [];
  checkPendingOrder: boolean = false;
  order;
  url;
  date = new Date()
  id;
  pic;
  nBlob: any;
  serviceInc: boolean = false;
  ChangeInc: boolean = false;
  map: any;
  marker: any;
  name;
  trainerFetch: boolean = true;
  completePop: boolean;
  custName;
  spName;
  code;
  lat; lan;
  orderAmount;
  storeObj: any;
  android;
  items: any = [];
  Type;
  contactNbrMob;
  serviceLoc: any = [];
  userLatLng: any;
  custLatLng: any;
  custLat: any;
  status;
  dateFormat;
  sid;
  criditValue;
  data;
  config;
  config1;
  userValue;
  clickedImage: any;
  changeId;
  checked: boolean = false;
  reasons;
  users: any = []; Name; UserId; orgId;
  options: CameraOptions = {
    quality: 30,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE
  }
  show: boolean = true;
  minbtn: boolean = true;
  maxbtn: boolean = false;
  orderItemsAllocated: any = [];
  minbtn1: boolean = true;
  maxbtn1: boolean = false;
  pName;
  search: any = [];
  search1: any = [];
  filterDate: any;
  list;
  orderCount;
  listDummy;
  pColour;
  pMake;
  pModel;
  pIdentity;
  pDate;
  resId;
  dummyList;
  singItems: any = [];
  subsObj;
  subsItems = [];
  newItems;
  showOpen: boolean = false;
  category;
  cateName;
  cateId;
  buttonName = "Show Active Only";
  currentDate;
  CalDate;
  custMob;
  routine;
  ondemand;
  subs;
  subsStatus;
  filterLength;
  filterLength1;
  requestTypes = [
    { name: "Change Allocation", id: '1' },
    // { name: "Reject Request", id: '2' },    
  ];

  orderTypes = [
    // { name: "Edit Order", id:'1'},
    // { name: "Add Items",id:'2'},
    // { name: "Update Cost",id:'3'},

  ];
  actions = [
    { name: "Accept", id: '1' },
    { name: "Reject", id: '2' },
  ];
  actionName;
  actionId;
  reqName;
  reqId;
  cId;
  confirm;
  cancelId;
  bell: boolean;
  subsCount;
  number;
  missedData: any = [];
  missedCheck: boolean = false;
  missedValue;
  missedId;
  openAllMap: boolean = true;
  mapData: any = [];
  DummypendingObj;
  pendSingle = [];
  confirmedOrderItems: any = [];
  openDetailPop: boolean = false;
  single;
  Orderstatus;
  startdate;
  enddate;
  fDate;
  eDate;
  constructor(public auth: AuthService, private nativeGeocoder: NativeGeocoder,
    private geolocation: Geolocation, public location: LocationService, private router: Router,
    public handler: HandlerService, private platform: Platform,
    public service: ApiService, private launchNavigator: LaunchNavigator,
    private camera: Camera, private bottomSheet: MatBottomSheet, public sanitizer: DomSanitizer
  ) { }

  ionViewWillEnter() {
    this.active = false;
    this.getConfig();
    sessionStorage.setItem('vendorApp', 'true');
    this.CalDate = this.returnDate(this.date);
    this.currentDate = this.returnDate(this.date);
    this.cId = localStorage.getItem('currentUserId');
    let url = window.location.href;
    this.dateFormat = this.auth.getDateformat();
    var date = new Date();
    this.startdate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.enddate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.getChange();
    this.getDailyStatus();
    this.getCategory();
    this.getCount();
    this.getMissedStaticData();
  }

  getRequests() {
    this.show = true;
    this.minbtn = true;
    this.maxbtn = false;
    this.checkPendingOrder = false;
    this.loader = true
    var date = new Date();
    let post = {
      "fromDate": this.returnDate(date),
      "toDate": this.returnDate(date)
    }
    this.url = window.location.href;
    this.id = localStorage.getItem('currentUserId');
    Object.assign(post, { serviceContractorId: this.id, statuses: [2, 3, 7, 8] });
    this.change = false;
    this.service.getAppointReq2(post).subscribe((res: any) => {
      if (res != null && res != "NO_CONTENT") {
        res.map(dat => {
          var a = dat.apptDate.split("T");
          Object.assign(dat, { date: a[0], present: false });
          var b = a[0].split("-");
          var c = b[1] + "/" + b[2] + "/" + b[0];
          var d = b[0] + "-" + b[1] + "-" + b[2];
          var todaysDate = new Date();
          var inputDate = new Date(c);
          var inputDate1 = new Date(d);
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
            Object.assign(dat, { present: true });
          }
          if (todaysDate < inputDate1) {
            Object.assign(dat, { present: true });
          }
        })
        this.newItems = res;
        this.dummyList = res;
        this.items = this.newItems.filter(res => { return (res.status == 3 || res.status == 7 || res.status == 8 || res.status == 2) && res.subscriptionInd == true })

        this.singItems = this.dummyList.filter(res => { return (res.status == 3 || res.status == 7 || res.status == 8 || res.status == 2) && res.subscriptionInd == false })
        console.log(this.singItems)
        this.items.map(res1 => {
          if (res1.custItem.identificationNo) {
            Object.assign(res1, { bikeNumber: res1.custItem.identificationNo, custFirstName: res1.requestor?.firstName, custLastName: res1.requestor?.lastName })
          } else {
            Object.assign(res1, { custFirstName: res1.requestor?.firstName, custLastName: res1.requestor?.lastName })
          }

        })
        this.singItems.map(res2 => {
          if (res2.custItem.identificationNo) {
            Object.assign(res2, { bikeNumber: res2.custItem.identificationNo, custFirstName: res2.requestor?.firstName, custLastName: res2.requestor?.lastName })
          } else {
            Object.assign(res2, { custFirstName: res2.requestor?.firstName, custLastName: res2.requestor?.lastName })
          }

        })
        this.routine = this.items.length;
        this.ondemand = this.singItems.length;
        this.getOrdersList();
      } else {
        this.items = [];
        this.singItems = [];
        this.getOrdersList();
        // this.handler.res('No data for you');  

      }
    }, err => {
      this.getOrdersList();
      this.handler.err(err)
    })

  }

  getOrdersList() {
    var date = new Date();
    let post1 = {
      "fromDate": this.returnDate(date),
      "toDate": this.returnDate(date)
    }
    this.url = window.location.href;
    this.id = localStorage.getItem('currentUserId');
    Object.assign(post1, { serviceContractorId: this.id, statuses: [3, 11, 10] });
    this.service.getOrders(post1).subscribe((res: any) => {
      if (res) {
        this.confirmedOrderItems = res;
        res.map(dat => {
          var a = dat.apptDate.split("T");
          Object.assign(dat, { date: a[0], present: false });
          var b = a[0].split("-");
          var c = b[1] + "/" + b[2] + "/" + b[0];
          var d = b[0] + "-" + b[1] + "-" + b[2];
          var todaysDate = new Date();
          var inputDate = new Date(c);
          var inputDate1 = new Date(d);
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
            Object.assign(dat, { present: true });
          }
          if (todaysDate < inputDate1) {
            Object.assign(dat, { present: true });
          }
        })
        this.confirmedOrderItems.map(res1 => {
          Object.assign(res1, { custLastName: res1.customer?.firstName })
        })
        this.confirmedOrderItems.map(dat => {
          this.category.map(dat1 => {
            if (dat.categoryId == dat1.id)
              Object.assign(dat, { categoryName: dat1.name })
          })
        })
        this.loader = false;
      } else {
        this.confirmedOrderItems = [];
        this.loader = false;
        // this.handler.res('No Orders for you');  
      }
    })
  }


  back() {
    this.ionViewWillEnter();
  }


  getMissedStaticData() {
    this.service.getMissedData().subscribe((res: any) => {
      this.missedData = res;
    })
  }

  convertTime(tim) {
    var time;
    time = tim.split(":");
    return time[0] + ":" + time[1]
  }

  newbook() {
    this.loader = true;
    this.getCount();
    let post = {};
    this.url = window.location.href;
    this.id = localStorage.getItem('currentUserId');
    this.change = true;
    this.subsStatus = 6;
    this.service.getConCustItemSubs(this.id, this.subsStatus).subscribe((res: any) => {
      if (res != null && res != "NO_CONTENT") {
        this.subsObj = res;
        this.subsItems = this.subsObj.filter(res => { return (res.status == 2 || res.status == 6 || res.status == 7 || res.status == 8 || res.status == 3) && res.serviceContractorId == this.id });
        this.subsItems.map(res1 => {
          Object.assign(res1, { bikeNumber: res1.custItems[0].identificationNo })
        })
        this.subs = this.subsItems.length;
        this.loader = false;
      } else {
        this.loader = false;
        this.subsItems = [];
        // this.handler.res("No Subscripton for you")
      }

    }, err => {
      this.loader = false;
      this.subsItems = [];
      this.handler.err(err)
    })
    this.status = 6;
    this.service.getVenAllConRequest(this.id, this.status).subscribe((res: any) => {
      if (res) {
        this.pendSingle = res;
        this.pendSingle = this.DummypendingObj.filter(res => { return res.subscriptionInd != null });

        this.pendSingle.map(res2 => {
          Object.assign(res2, { bikeNumber: res2.identificationNumber, custFirstName: res2.requestor?.firstName, custLastName: res2.requestor?.lastName })
        })
        this.loader = false;
      } else {
        this.loader = false;
        this.pendSingle = [];
        //  this.handler.res('No On Demand Service For You')
      }
    }, err => {
      this.loader = false;
      this.pendSingle = [];
      this.handler.err(err)
    })
    this.Orderstatus = 12;
    this.service.getConOrdersByStatus(this.id, this.Orderstatus).subscribe((res: any) => {
      if (res) {
        this.orderItemsAllocated = res;
        this.orderItemsAllocated.map(res1 => {
          Object.assign(res1, { custLastName: res1.customer?.firstName })
        })
        this.orderItemsAllocated.map(dat => {
          this.category.map(dat1 => {
            if (dat.categoryId == dat1.id)
              Object.assign(dat, { categoryName: dat1.name })
          })
        })

        this.loader = false;
      } else {
        this.orderItemsAllocated = [];
        this.loader = false;
        //  this.handler.res('No Orders for you');  
      }
    })
  }


  getDailyStatus() {
    this.service.getDailyStatus().subscribe(res => {
      this.status = res;
    })
  }



  getChange() {
    this.service.getReasons().subscribe(res => {
      this.reasons = res;
    })
  }


  markedTime(value) {
    if (value) {
      var x = value.split("T");
      var y = x[1].slice(0, 5);
      return y
    }
  }
  get() {
    this.loader = true;
    this.service.getOrg().subscribe(res => {
      if (res) {
        this.storeObj = res;
        this.loader = false;
      }
      else {
        this.storeObj = [];
        this.loader = false;
        // this.handler.res('No Data To Show')
      }

    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }

  getIdentification(data) {
    if (data.custItems) {
      if (data.custItems[0].identificationNo) {
        return data.custItems[0].identificationNo
      }
    }
  }

  openImage(data) {
    this.popImg = data;
    this.imgView = true;
  }

  captureImage(id) {
    if (this.platform.ANDROID || this.platform.IOS) {
      this.camera.getPicture(this.options).then((imageData: any) => {
        if (imageData) {
          let base64Image = 'data:image/jpeg;base64,' + imageData;
          this.clickedImage = base64Image;
          this.NotInPlace(id);
        } else {
          this.blobData(id)
        }
      });
    } else {
      this.blobData(id)
    }
  }

  blobData(id) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "assets/icon/seden.jpeg", true);
    xhr.responseType = "blob";
    var obj = this;
    xhr.onload = function (e) {
      var reader = new FileReader();
      reader.onload = function (event) {
        var res = event.target.result;
      }
      obj.nBlob = this.response;
      reader.readAsDataURL(obj.nBlob);
      obj.NotInPlace(id);
    };
    xhr.send()
  }

  DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];
    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)
    return new Blob([ia], { type: mimeString })
  }

  NotInPlace(id) {
    this.loader = true;
    let y = this.status.find(res => res.name == "NotInPlace");
    let a = y.id;
    var file
    if (this.platform.ANDROID || this.platform.IOS) {
      file = this.DataURIToBlob(this.clickedImage)
    } else {
      file = this.nBlob;
    }
    setTimeout(() => {
      this.service.notInPlace(id, a, file).subscribe((res: any) => {
        sessionStorage.setItem("clickValue", id)
        this.handler.res('Status Updated Successfully !!')
        this.getRequests();
        this.loader = false;
      },
        err => {
          this.loader = false;
          this.handler.err(err)
        })
    }, 1000);

  }

  getImage(id) {
    this.loader = true;
    this.service.getDocumentImg(id).subscribe(res => {
      this.popImg = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      this.imgView = true;
      this.loader = false;
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })
  }

  closePop() {
    this.imgView = false;
    this.popImg = undefined;
  }


  Missed() {
    let y = this.status.find(res => res.name == "Missed");
    let a = y.id;
    let post = {
      "id": this.missedId,
      "status": a,
      "missedReasons": this.missedValue
    }
    this.service.missed(post, this.missedId).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!')
      this.missedCheck = false;
      this.getRequests();
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }

  Completed(id) {
    let y = this.status.find(res => res.name == "Completed");
    let a = y.id;
    let post = {
      "id": id,
      "status": a,
    }
    this.service.completed(post, id).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!')
      this.getRequests();
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }

  updateReason() {
    let post = {
      "id": this.resId,
      "status": 2,
      "reason": this.changeId
    }
    this.service.updateReasons(post, this.resId).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!')
      this.getRequests();
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }
  clearCapture() {
    this.clickedImage = ""
    this.ChangeInc = false;
    this.updateReason();
  }



  getStoreLoc() {
    let loc = this.storeObj.filter(res => res.addresses.length > 0);
    this.serviceLoc = loc.filter(res => res.addresses[0].lat);
  }




  openMap(data) {
    if (this.platform.ANDROID || this.platform.IOS) {
      navigator.geolocation.getCurrentPosition(res => {
        this.lat = res.coords.latitude,
          this.lan = res.coords.longitude;
      },
        err => {
          this.handler.err(err)
        })
    }
    if (data.address) {
      var cLat = data?.address?.lat;
      var cLon = data?.address?.lon;
    } else {
      var cLat = data?.lat;
      var cLon = data?.lon;
    }
    if (cLat != "" && cLon != "") {
      this.mapView = false;
      setTimeout(() => {
        this.userLatLng = [this.lat, this.lan];
        this.custLat = [cLat, cLon];
        this.custLatLng = new google.maps.LatLng(cLat, cLon);
        let pos = new google.maps.LatLng(this.lat, this.lan);
        let mapOptions = {
          center: pos,
          zoom: 100,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        this.marker = new google.maps.Marker({
          position: pos,
          animation: google.maps.Animation.DROP,
          map: this.map
        });
        this.startNavigating(pos)
      }, 2000);
    } else {
      var err = "Address Not Found"
      this.handler.err(err)
    }


  }

  startNavigating(pos) {
    let directionsService = new google.maps.DirectionsService;
    let directionsDisplay = new google.maps.DirectionsRenderer;
    directionsDisplay.setMap(this.map);
    directionsService.route({
      origin: pos,
      destination: this.custLatLng,
      travelMode: google.maps.TravelMode['DRIVING']
    }, (res, status) => {
      if (status == google.maps.DirectionsStatus.OK) {
        directionsDisplay.setDirections(res);
      } else {
      }
    });
  }

  navigate() {
    let options: LaunchNavigatorOptions = {
      start: this.userLatLng,
    }
    this.launchNavigator.navigate(this.custLat, options)
      .then(
        success => this.mapView = false,
        error => { }
      );
  }


  handleFile(files) {
    if (files[0].size < 1048576) {
      var img = new Image();
      img.src = URL.createObjectURL(files[0]);
      img.onload = (data) => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        this.pic = canvas.toDataURL('image/jpeg', 1.5);
      }
    }
    else {
      this.handler.res('Image Size Should Not Exceeds 1mb ');
    }

  }

  getMissed(id) {
    this.missedId = id;
    this.missedCheck = true;
  }

  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year + '-' + month + '-' + date;
  }

  next() {
    let x = new Date(JSON.parse(JSON.stringify(this.CalDate)));
    let newDate = new Date(x.setDate(x.getDate() + 1));
    this.CalDate = newDate;
    this.rangeDate()
  }

  prev() {
    let x = new Date(JSON.parse(JSON.stringify(this.CalDate)));
    let newDate = new Date(x.setDate(x.getDate() - 1));
    this.CalDate = newDate
    this.rangeDate()
  }


  rangeDate() {
    this.loader = true;
    this.show = true;
    this.minbtn = true;
    this.maxbtn = false;
    let post = {
      "fromDate": this.returnDate(this.CalDate),
      "toDate": this.returnDate(this.CalDate)
    }
    Object.assign(post, { "serviceContractorId": localStorage.getItem('currentUserId') })
    this.change = false;
    this.service.getAppointReq2(post).subscribe((res: any) => {
      this.filterDate = "";
      if (res != null && res != "NO_CONTENT") {
        res.map(dat => {
          var a = dat.apptDate.split("T");
          Object.assign(dat, { date: a[0], present: false });
          var b = a[0].split("-");
          var c = b[1] + "/" + b[2] + "/" + b[0];
          var d = b[0] + "-" + b[1] + "-" + b[2];
          var todaysDate = new Date();
          var inputDate = new Date(c);
          var inputDate1 = new Date(d);
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
            Object.assign(dat, { present: true });
          }
          if (todaysDate < inputDate1) {
            Object.assign(dat, { present: true });
          }
        })
        this.newItems = res;
        this.dummyList = res;
        this.items = this.newItems.filter(res => { return (res.status == 3 || res.status == 7 || res.status == 8 || res.status == 2) && res.subscriptionInd == true })
        this.singItems = this.dummyList.filter(res => { return (res.status == 3 || res.status == 7 || res.status == 8 || res.status == 2) && res.subscriptionInd == false })
        this.items.map(res1 => {
          Object.assign(res1, { bikeNumber: res1.custItem.identificationNo, custFirstName: res1.requestor?.firstName, custLastName: res1.requestor?.lastName })
        })
        this.singItems.map(res2 => {
          Object.assign(res2, { bikeNumber: res2.custItem.identificationNo, custFirstName: res2.requestor?.firstName, custLastName: res2.requestor?.lastName })
        })
        let post1 = {
          "fromDate": this.returnDate(this.CalDate),
          "toDate": this.returnDate(this.CalDate)
        }
        this.id = localStorage.getItem('currentUserId');
        Object.assign(post1, { serviceContractorId: this.id, statuses: [3, 11, 10] });
        this.service.getOrders(post1).subscribe((res: any) => {
          if (res) {
            this.confirmedOrderItems = res;
            res.map(dat => {
              var a = dat.apptDate.split("T");
              Object.assign(dat, { date: a[0], present: false });
              var b = a[0].split("-");
              var c = b[1] + "/" + b[2] + "/" + b[0];
              var d = b[0] + "-" + b[1] + "-" + b[2];
              var todaysDate = new Date();
              var inputDate = new Date(c);
              var inputDate1 = new Date(d);
              if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
                Object.assign(dat, { present: true });
              }
              if (todaysDate < inputDate1) {
                Object.assign(dat, { present: true });
              }
            })
            this.confirmedOrderItems.map(res1 => {
              Object.assign(res1, { custLastName: res1.customer?.firstName })
            })
            this.confirmedOrderItems.map(dat => {
              this.category.map(dat1 => {
                if (dat.categoryId == dat1.id)
                  Object.assign(dat, { categoryName: dat1.name })
              })
            })

            this.loader = false;
          } else {

            this.confirmedOrderItems = [];
            this.loader = false;
            // this.handler.res('No Orders for you');  
          }
        })

        this.loader = false;
      } else {
        this.items = [];
        this.singItems = [];
        this.loader = false;
        // this.handler.res('No data for you');  
        let post1 = {
          "fromDate": this.returnDate(this.CalDate),
          "toDate": this.returnDate(this.CalDate)
        }
        this.id = localStorage.getItem('currentUserId');
        Object.assign(post1, { serviceContractorId: this.id, statuses: [3, 11, 10] });
        this.service.getOrders(post1).subscribe((res: any) => {
          if (res) {
            this.confirmedOrderItems = res;
            res.map(dat => {
              var a = dat.apptDate.split("T");
              Object.assign(dat, { date: a[0], present: false });
              var b = a[0].split("-");
              var c = b[1] + "/" + b[2] + "/" + b[0];
              var d = b[0] + "-" + b[1] + "-" + b[2];
              var todaysDate = new Date();
              var inputDate = new Date(c);
              var inputDate1 = new Date(d);
              if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
                Object.assign(dat, { present: true });
              }
              if (todaysDate < inputDate1) {
                Object.assign(dat, { present: true });
              }
            })
            this.confirmedOrderItems.map(res1 => {
              Object.assign(res1, { custLastName: res1.customer?.firstName })
            })
            this.confirmedOrderItems.map(dat => {
              this.category.map(dat1 => {
                if (dat.categoryId == dat1.id)
                  Object.assign(dat, { categoryName: dat1.name })
              })
            })

            this.loader = false;
          } else {

            this.confirmedOrderItems = [];
            this.loader = false;
            // this.handler.res('No Orders for you');  
          }
        })
      }
    }, err => {
      this.loader = false;
      this.handler.err(err)
      let post1 = {
        "fromDate": this.returnDate(this.CalDate),
        "toDate": this.returnDate(this.CalDate)
      }
      this.id = localStorage.getItem('currentUserId');
      Object.assign(post1, { serviceContractorId: this.id, statuses: [3, 11, 10] });
      this.service.getOrders(post1).subscribe((res: any) => {
        if (res) {
          this.confirmedOrderItems = res;
          res.map(dat => {
            var a = dat.apptDate.split("T");
            Object.assign(dat, { date: a[0], present: false });
            var b = a[0].split("-");
            var c = b[1] + "/" + b[2] + "/" + b[0];
            var d = b[0] + "-" + b[1] + "-" + b[2];
            var todaysDate = new Date();
            var inputDate = new Date(c);
            var inputDate1 = new Date(d);
            if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
              Object.assign(dat, { present: true });
            }
            if (todaysDate < inputDate1) {
              Object.assign(dat, { present: true });
            }
          })
          this.confirmedOrderItems.map(res1 => {
            Object.assign(res1, { custLastName: res1.customer?.firstName })
          })
          this.confirmedOrderItems.map(dat => {
            this.category.map(dat1 => {
              if (dat.categoryId == dat1.id)
                Object.assign(dat, { categoryName: dat1.name })
            })
          })

          this.loader = false;
        } else {

          this.confirmedOrderItems = [];
          this.loader = false;
          // this.handler.res('No Orders for you');  
        }
      })
    })

  }

  getReason(id) {
    this.resId = id;
    this.ChangeInc = true;
  }

  clearArray(value) {
    this.changeId = value.id;
  }

  clearArray1(value) {
    this.missedValue = value.id;
  }



  dateSearch() {
    // this.loader = true;
    let month = this.date.getMonth() + 1;
    var fmon;
    month < 10 ? fmon = '0' + month : fmon = month;
    let day = this.date.getDate();
    var fday;
    day < 10 ? fday = '0' + day : fday = day;
    let date = fday + '-' + fmon + '-' + this.date.getFullYear();
    let post = {
      "schElements": [1],
      "requestDate": date,
      "status": ["SlotsAvailable"],
      trainerFetch: this.trainerFetch
    }

  }

  Vendorselect(id) {
    this.router.navigate(['/assignVendor/', +id]);

  }

  vendoruser() {
    this.id = localStorage.getItem('organizationId');
    this.service.getUsersByOrg('SC', this.id, null).subscribe(res => {
      this.users = res;
      this.users = this.users.filter(res => { return res.reqRoleApproved })
    })
  }


  openPop(data) {
    this.serviceInc = true
    this.pName = data.providerService.name;
    this.pColour = data.custItem.colour;
    this.pMake = data.custItem.make;
    this.pModel = data.custItem.model;
    this.pIdentity = data.custItem.identificationNo;
    this.custName = data.custItem.custName;
    this.custMob = data.custItem.contactNbrMob;
  }

  openPop1(data) {
    this.serviceInc = true
    this.pName = data.services[0].name;
    this.pColour = data.custItems[0].colour;
    this.pMake = data.custItems[0].make;
    this.pModel = data.custItems[0].model;
    this.pIdentity = data.custItems[0].identificationNo;
    this.custName = data.custItems[0].custName;
    this.custMob = data.custItems[0].contactNbrMob;

  }

  ionViewWillLeave() {
    this.Name = undefined;
    this.search = "";
    this.search = [];
    this.search1 = [];
    this.search1 = "";
  }

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      if (res) {
        this.category = res;
        this.getRequests();
        // this.getOrdersList();
      }

    })
  }

  openBottomSheetItemCategory() {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.category,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.cateName = res.name;
        this.cateId = res.id;
      }
    });
  }

  refreshData(event) {
    if (!this.change) {
      this.ionViewWillEnter();
    } else {
      this.newbook();
    }

    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  showActiveData() {
    if (this.buttonName == "Show Active Only") {
      this.buttonName = "Show All"
      this.items = this.newItems.filter(res => { return (res.status == 2) && res.subscriptionInd == true })
      this.singItems = this.dummyList.filter(res => { return (res.status == 2) && res.subscriptionInd == false })
    } else {
      this.buttonName = "Show Active Only"
      this.items = this.newItems.filter(res => { return (res.status == 2 || res.status == 3 || res.status == 7 || res.status == 8) && res.subscriptionInd == true })
      this.singItems = this.dummyList.filter(res => { return (res.status == 2 || res.status == 3 || res.status == 7 || res.status == 8) && res.subscriptionInd == false })
    }

  }


  openBottomSheetOrderTypes(data): void {
    if (data.present && data.status == 10) {
      sessionStorage.setItem('orderId', data.id);
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.orderTypes,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.reqName = res.name;
          this.reqId = res.id;
          if (this.reqId == 1) {
            this.router.navigate(['contractor-order-edit/', +data.categoryId])
          }
          if (this.reqId == 2) {
            this.router.navigate(['/contractor-Purchase-category'])
          }
        }
      });
    } else {
      this.handler.res("No Actions Found")
    }

  }


  getCount() {
    this.service.summaryReq().subscribe((res: any) => {
      if (res) {
        this.subsCount = res;
        this.getOrderCount();
      } else {
        this.subsCount = 0;
        this.getOrderCount();
      }

    })
  }


  getOrderCount() {
    this.service.getOrderSummary(localStorage.getItem('currentUserId')).subscribe((res1: any) => {
      if (res1) {
        this.orderCount = res1;
        this.number = this.subsCount + this.orderCount;
      } else {
        this.orderCount = 0
        this.number = this.subsCount + this.orderCount;
      }
      if (this.number >= 1) {
        this.bell = true;
      }
    })
  }


  minimize() {
    this.show = false;
    this.maxbtn = true;
    this.minbtn = false;
  }

  maximize() {
    this.show = true;
    this.minbtn = true;
    this.maxbtn = false;
  }

  mini() {
    this.show = false;
    this.maxbtn1 = true;
    this.minbtn1 = false;
  }

  max() {
    this.show = true;
    this.minbtn1 = true;
    this.maxbtn1 = false;
  }

  openMap1() {
    if (this.platform.ANDROID) {
      navigator.geolocation.getCurrentPosition(res => {
        this.lat = res.coords.latitude,
          this.lan = res.coords.longitude;
      },
        err => {
          this.handler.err(err)
        })
    }
    this.loader = true;
    this.openAllMap = false;
    setTimeout(() => {
      let pos = new google.maps.LatLng(this.lat, this.lan);
      let mapOptions = {
        center: pos,
        zoom: 10,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      var icon = 'assets/pin.png';
      if (this.items && this.items.length > 0) {
        this.items.map(res => {
          if (res.address?.lat && res.address?.lon) {
            let lat = Number(res.address.lat)
            let lon = Number(res.address.lon)
            this.marker = new google.maps.Marker({
              position: new google.maps.LatLng(lat, lon),
              animation: google.maps.Animation.DROP,
              map: this.map,
              icon: icon
            });
            var infoWindow = new google.maps.InfoWindow({
              content: res.requestor.firstName
            });
            infoWindow.open(this.map, this.marker);
          }
        }
        )
      }
      this.loader = false;
    }, 5000);
  }


  ngDoCheck(): void {
    this.filterLength = sessionStorage.getItem('len')
    setTimeout(() => {
      this.filterLength1 = sessionStorage.getItem('len1')
    }, 1000);
  }

  getServiceName(data) {
    if (data.services) {
      if (data.services[0]) {
        return data.services[0]?.name
      }
    }
  }

  accept(data) {
    this.loader = true;
    this.url = window.location.href;
    let post = {
      "apptDate": data.apptDate,
      "serviceContractorId": data.serviceContractorId,
      "targetSource": data.serviceContractorId,
      "apptEndTime": data.apptEndTime,
      "apptTime": data.apptTime,
    }

    let url = window.location.href;
    this.service.confirmEmpReq(data.id, post).subscribe(res => {
      this.loader = false;
      this.handler.res('Request Confirmed Successfully !!');
      this.getRequests()
      this.getCount()
    })
  }

  openBottomSheetItemAction(data) {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.actions,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.actionName = res.name;
        this.actionId = res.id;
        if (this.actionId == 1) {
          this.accept(data);
        }
        if (this.actionId == 2) {
          this.reject(data);
        }
      }
    });
  }
  reject(data) {
    this.service.RequestReject(data.id).subscribe(res => {
      this.handler.res('Request rejected sucessfully!!!')
      this.getRequests();
      this.getCount();
    })
  }

  openBottomSheetOrderAction(data) {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.actions,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        this.actionName = res.name;
        this.actionId = res.id;
        if (this.actionId == 1) {
          this.acceptOrder(data);
        }
        if (this.actionId == 2) {
          this.rejectOrder(data);
        }
      }
    });
  }
  rejectOrder(data) {
    this.service.OrderReject(data.id).subscribe(res => {
      this.handler.res('Order rejected sucessfully!!!')
      this.getRequests()
      this.getCount();
    })
  }

  acceptOrder(data) {
    this.loader = true;
    this.url = window.location.href;
    let post = {
      "apptDate": data.apptDate,
      "serviceContractorId": data.serviceContractorId,
      "targetSource": data.serviceContractorId,
      "apptEndTime": data.apptEndTime,
      "apptTime": data.apptTime,
    }

    let url = window.location.href;
    this.service.confirmEmpOrder(data.id, post).subscribe(res => {
      this.loader = false;
      this.handler.res('Order Confirmed Successfully !!');
      this.getRequests();
      this.getCount();
    })
  }
  clear() {
    this.search = "";
    this.search1 = "";
  }

  popUpOpen(data) {
    this.itemOrders = data.itemOrders;
    this.notes = data.notes;
    this.openDetailPop = true;
  }

  openOrderRequests(data) {
    this.router.navigate(['/con-requests/', data.id])
  }
  openOrderEdit(data) {
    if (data.present && data.status == 10) {
      sessionStorage.setItem('orderId', data.id);
      sessionStorage.setItem('catId', data.categoryId);
      sessionStorage.setItem('vendor', data.vendorId);
      this.router.navigate(['contractor-order-edit/', +data.categoryId])
    } else {
      this.handler.res("No Actions Found")
    }
  }
  pendingOrderEdit(data) {
    if (data.status == 10) {
      sessionStorage.setItem('orderId', data.id);
      sessionStorage.setItem('catId', data.categoryId);
      sessionStorage.setItem('vendor', data.vendorId);
      this.router.navigate(['contractor-order-edit/', +data.categoryId])
    } else {
      this.handler.res("No Actions Found")
    }
  }

  changeApp() {
    sessionStorage.setItem('vendorApp', 'false')
    if (this.active) {
      if (this.auth.loged()) {
        this.router.navigate(['/bookservice1'])
      } else {
        this.router.navigate(['/bookservice'])
      }

    } else {
      if (this.auth.loged()) {
        this.router.navigate(['/vendor-register1'])
      } else {
        this.router.navigate(['/vendor-register'])
      }

    }
  }


  newOrderEdit(data) {
    sessionStorage.setItem('orderId', data.id);
    this.router.navigate(['contracter-new-order/', +data.categoryId])
  }

  pendingActions() {
    this.loader = true;
    this.checkPendingOrder = true;
    this.status = 10
    var start = this.returnDate(this.startdate);
    var end = this.returnDate(this.enddate)
    this.service.getConOrdersByDate(this.id, this.status, start, end).subscribe((res: any) => {
      if (res) {
        res.map(dat => {
          var a = dat.apptDate.split("T");
          Object.assign(dat, { date: a[0], present: false, custFirstName: dat.requestor?.firstName, custLastName: dat.requestor?.lastName });
          var b = a[0].split("-");
          var c = b[1] + "/" + b[2] + "/" + b[0];
          var d = b[0] + "-" + b[1] + "-" + b[2];
          var todaysDate = new Date();
          var inputDate = new Date(c);
          var inputDate1 = new Date(d);
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
            Object.assign(dat, { present: true });
          }
          if (todaysDate < inputDate1) {
            Object.assign(dat, { present: true });
          }
        })
        this.pendingOrders = res;
        this.pendingOrders.map(res1 => {
          Object.assign(res1, { custLastName: res1.customer?.firstName })
        })
        this.pendingOrders.map(dat => {
          this.category.map(dat1 => {
            if (dat.categoryId == dat1.id)
              Object.assign(dat, { categoryName: dat1.name })
          })
        })

        this.loader = false;
      } else {
        this.orderItemsAllocated = [];
        this.loader = false;
        // this.handler.res('No Orders for you');  
      }
    })
  }
  startDate() {
    this.fDate = this.returnDate(this.startdate);
    this.enddate = ""
  }
  endDate() {
    this.loader = true;
    this.checkPendingOrder = true;
    this.status = 10
    this.fDate = this.returnDate(this.startdate);
    this.eDate = this.returnDate(this.enddate);
    this.service.getConOrdersByDate(this.id, this.status, this.fDate, this.eDate).subscribe((res: any) => {
      if (res) {
        res.map(dat => {
          var a = dat.apptDate.split("T");
          Object.assign(dat, { date: a[0], present: false, custFirstName: dat.requestor?.firstName, custLastName: dat.requestor?.lastName });
          var b = a[0].split("-");
          var c = b[1] + "/" + b[2] + "/" + b[0];
          var d = b[0] + "-" + b[1] + "-" + b[2];
          var todaysDate = new Date();
          var inputDate = new Date(c);
          var inputDate1 = new Date(d);
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
            Object.assign(dat, { present: true });
          }
          if (todaysDate < inputDate1) {
            Object.assign(dat, { present: true });
          }
        })
        this.pendingOrders = res;
        this.pendingOrders.map(res1 => {
          Object.assign(res1, { custLastName: res1.customer?.firstName })
        })
        this.pendingOrders.map(dat => {
          this.category.map(dat1 => {
            if (dat.categoryId == dat1.id)
              Object.assign(dat, { categoryName: dat1.name })
          })
        })

        this.loader = false;
      } else {
        this.orderItemsAllocated = [];
        this.loader = false;
        // this.handler.res('No Orders for you');  
      }
    })

  }

  async getConfig() {
    this.data = await this.service.getConfig().toPromise();
    if (this.data) {
      let x = this.data.find(res => res.name == "Billing Config");
      this.config = x.configs.find(dat => dat.shortCdConst == "TVC");
      this.config1 = x.configs.find(dat => dat.shortCdConst == "ACP");
      this.userValue = this.config.userValue;
      this.criditValue = this.config1.userValue;

    }
  }

  complete(item) {
    sessionStorage.setItem("orgId", item.orgId);
    this.order = item;
    this.completePop = true;
    this.actCost = undefined;
  }

  cancelComplete() {
    this.completePop = false;
  }

  async finish() {
    this.loader = true;
    var post;
    console.log(this.order);
    post = {
      actCost: this.actCost,
    };
    console.log(post);
    this.service.fixedOrder(this.order.id, post).subscribe(
      (res) => {
        this.handler.res('Status Updated Successfully !!');
        this.completePop = false;
        this.router.navigate(['/requests'])
        this.ionViewWillEnter();
      },
      (err) => {
        this.loader = false;
        this.handler.err(err);
        this.completePop = false;
      }
    );
  }


}
